export default __webpack_public_path__ + "static/flashcard_fish_bowl-938c71b3136100e60f64a014e267996e.png";